import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { STATUS_OPTIONS, STATUS_STYLES, STATUS_DOT } from "@/components/StatusBadge";
import { cn } from "@/lib/utils";

/**
 * Inline, editable status pill. Looks like the StatusBadge but lets the user
 * change a task's status directly (calls onChange with the new value). Safe to
 * place inside clickable rows — it stops click propagation.
 */
export default function StatusSelect({
    value,
    onChange,
    disabled,
    className,
    options = STATUS_OPTIONS,
    styles = STATUS_STYLES,
    dot = STATUS_DOT,
}) {
    return (
        <Select value={value} onValueChange={onChange} disabled={disabled}>
            <SelectTrigger
                onClick={(e) => e.stopPropagation()}
                data-testid={`status-select-${value}`}
                className={cn(
                    "h-7 w-auto gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0 text-xs font-medium focus:ring-1 focus:ring-offset-0",
                    styles[value] || "bg-muted text-muted-foreground border-border",
                    className,
                )}
            >
                <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", dot[value])} />
                <SelectValue />
            </SelectTrigger>
            <SelectContent onClick={(e) => e.stopPropagation()}>
                {options.map((s) => (
                    <SelectItem key={s.value} value={s.value}>
                        {s.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
